import { defaultTheme } from 'react-admin';

export const coxTheme = {
  name: 'cox',
  logo: 'cox.svg',
  palette: {
    primary: {
      main: '#154953',
      dark: '#233c71',
    },
    secondary: {
      light: '#5f5fc4',
      main: '#283593',
      dark: '#233c71',
      contrastText: '#fff',
    },
    background: {
      default: '#fcfcfe',
    },
    mode: 'light' as 'light',
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    ...defaultTheme.components,
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: '#fff',
          backgroundColor: '#154953',
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          'color': '#aaa',
          'borderLeft': '3px solid #981b2f',
          '&.RaMenuItemLink-active': {
            'borderLeft': '3px solid #fff',
            'color': '#fff',
            '& .RaMenuItemLink-icon': {
              color: '#fff',
            },
          },
          '& .RaMenuItemLink-icon': {
            color: '#aaa',
          },
        },
      },
    },
    RaFileInput: {
      styleOverrides: {
        root: {
          '& .RaFileInput-dropZone': { background: '#f5f5f5' },
        },
      },
    },
    RaImageInput: {
      styleOverrides: {
        root: {
          '& .RaFileInput-dropZone': { background: '#f5f5f5' },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          backgroundColor: '#154953',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: 'none',
        },
        root: {
          backgroundClip: 'padding-box',
        },
      },
    },
  },
};
